import React, { useEffect, useState } from 'react';
import { getStudentAttendanceReport, getMappedPrograms } from '../../../services/AppManagement/AttendanceService';
import { tableConstants } from './AttendanceReportPercentageTableConst';
import Table from '../../../components/Table/Table';
import Loader from '../../../components/Loader/Loader';
import CardHeader from '../../../components/Card/CardHeader';
import Select from '../../../components/Select/Select';
import { useNavigate } from 'react-router-dom';
import { FaCalendarAlt } from 'react-icons/fa';
import './AttendanceReport.css';
import Button from '../../../components/Button/Button';
import { enqueueSnackbar } from 'notistack';
import * as XLSX from 'xlsx';

const AttendanceReportPercentage = () => {
  const [data, setData] = useState([]);
  const [loader, setLoader] = useState(false);
  const [programData, setProgramData] = useState([]);
  const navigate = useNavigate();

  const fetchAttendanceReportPercentage = async (program_id) => {
    if (!program_id) {
      console.error('Please select a program.');
      return;
    }
    try {
      setLoader(true);
      // Assuming you have a service function to fetch the attendance report percentage
      const response = await getStudentAttendanceReport(program_id);
      // Check if the response is successful
      if (response.status === 200) {
        setData(response.data.data);
      }
    } catch (error) {
      console.error("API Error:", error);
    }
    finally {
      setLoader(false);
    }
  }

  const fetchMappedPrograms = async (id) => {
    try {
      const response = await getMappedPrograms(id);
      if (response.status === 200) {
        let programs = response.data.data.attendances.map((item) => {
          return {
            id: item.program.id,
            name: item.program.name
          };
        });
        setProgramData(programs);
      }
    }
    catch (error) {
      console.error("API Error:", error);
    }
  };

  const downloadExcel = () => {
    if (!data || data.length === 0) {
      enqueueSnackbar('No data available to download', { variant: 'warning' });
      return;
    }
    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, `attendance-report.xlsx`);
  };

  useEffect(() => {
    let user_id = JSON.parse(localStorage.getItem('user')).id;;
    fetchMappedPrograms(user_id);
  }
    , []);

  const back = () => {
    navigate('/attendance/list');
  };
  return (
    <div className="card">
      <CardHeader
        title="Attendance"
        icon={<FaCalendarAlt />}
        button={
          <React.Fragment>
            <Button className='mx-1'
              variant="success"
              type="button"
              onClick={downloadExcel}>
              Download Excel
            </Button>
            <Button className='mx-1'
              variant="primary"
              type="button"
              onClick={back}>
              Back
            </Button>
          </React.Fragment>
        }
      />
      <div className="card-body report-table-container">
        <div className="row">
          <div className="col-md-6">
            <Select
              name="program_id"
              placeholder={'Select Class'}
              onChangeHandler={(e) => { fetchAttendanceReportPercentage(e.target.value) }}
              options={programData}
            />
          </div>
        </div>
        {loader ? <Loader /> :
          <div className="row mt-3">
            {data && data.length > 0 && (
              <Table
                cols={tableConstants(data)}
                data={data}
                hover={true}
              />
            )}
          </div>}
      </div>
    </div>
  );
};

export default AttendanceReportPercentage;
